import React from 'react';

/**
 * What the AI/MCP pages show where a value would go while no data source
 * feeds them (GH #3969, .claude/rules/no-fabricated-values.md). Wiring them to
 * the SocketCloud egress gateway's pass-through log and the Conductor's run
 * records is a later GH #3958 unit; until then a page shows this state and
 * never a number, model name or status of its own making.
 */
export const NOT_MEASURED = 'Not measured';

/** Badge text for a page with no data source behind it. */
export const NO_DATA_SOURCE = 'No data source';

/** One line explaining why a list or panel is empty. */
export const NotMeasuredNotice: React.FC<{ message: string }> = ({ message }) => (
  <div role="status" className="rounded-lg border border-gray-700 bg-gray-800/60 p-4 text-sm text-gray-400">
    {message}
  </div>
);
